import React from 'react'
import { useLocation } from 'react-router-dom';
import './style.css'


const GradeDisplay = () => {
    const location = useLocation();
    const data = location.state;
    console.log("data", data)
    return (
    
            <div className='container displaybox'>
            <h3 className='text-center'>Student Information</h3>
               <div className='maindiv'>
                      <span>Name:{data.sname}</span>
                      <span> Enrollment No:{data.rollno}</span>
                      <span>Current Standard:{data.standard}</span>
                      <span>email:{data.email}</span>
                        
                        
                        </div>

                <div className="container  gradebox"  >
                <h4 className='text-center'>Grade History</h4>

                    <table  border={2} className='table table-striped' style={{margin:"auto"}}>
                        <thead>
                            <tr className='table-secondary'>
                                <th scope="col">Standard</th>
                                <th scope="col">Remarks</th>
                                <th scope="col">Percentage</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                  
                    {
                        data.stds.map((curr, index) => {
                            return (
                                <tr>
                                    <td> {curr.std} </td>
                                    <td> {curr.remark} </td>
                                    <td>{curr.percentage} </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                    </table>
                    <div className="" style={{alignItems:"center"}}>
                    <button onClick={()=>{window.print() }} > Print </button>
                    </div>
                  
                </div>



            </div>
        
    )
}

export default GradeDisplay